module.exports = __webpack_public_path__ + "static/media/mama.3bb099cd.png";